<template>
    <div class="firsecond_content">
        <div class="middletf">
            <div class="firsecond_top">
                <p>平台服务</p>
                <img src="../../img/service.png" class="top_img" />
            </div>
            <div class="firsecond_bottom">
                <div class="mySecond" @click="mysecondJump('1')">
                    <img class="my_img" src="./../../img/first02.png" alt="区块链司法存证" />
                    <p class="my_p1">区块链司法存证</p>
                    <p class="my_p2" style="margin:8px 0;">直通互联网法院</p>
                    <p class="my_p3">司法认可的区块链存证</p>
                    <div class="jiantou">
                        <span class="show_span">了解详情</span>
                        <img src="./../../img/first01.png" class="img1" />
                        <img src="./../../img/first00.png" class="img2" />
                    </div>
                </div>
                <div class="mySecond" @click="mysecondJump('6')" style="margin-left: 30px;">
                  <img class="my_img" src="./../../img/first07.png" alt="预登记" />
                  <p class="my_p1">预登记</p>
                  <p class="my_p2" style="margin:8px 0;">海量作品确权</p>
                  <p class="my_p3">审核时间短、成本低</p>
                  <div class="jiantou">
                    <span class="show_span">了解详情</span>
                    <img src="./../../img/first01.png" class="img1" />
                    <img src="./../../img/first00.png" class="img2" />
                  </div>
                </div>
                <div class="mySecond" @click="mysecondJump('2')" style="margin:0 31px;">
                    <img class="my_img" src="./../../img/first03.png" alt="版权监测" />
                    <p class="my_p1">版权监测</p>
                    <p class="my_p2" style="margin:8px 0;">文字、图片、监测</p>
                    <p class="my_p3">高准确度、操作简便</p>
                    <div class="jiantou">
                        <span class="show_span">了解详情</span>
                        <img src="./../../img/first01.png" class="img1" />
                        <img src="./../../img/first00.png" class="img2" />
                    </div>
                </div>
                <div class="mySecond" @click="mysecondJump('3')">
                    <img class="my_img" src="./../../img/first04.png" alt="司法取证" />
                    <p class="my_p1">司法取证</p>
                    <p class="my_p2" style="margin:8px 0;">区块链上链记录、</p>
                    <p class="my_p3">取证证据直通互联网法院</p>
                    <div class="jiantou">
                        <span class="show_span">了解详情</span>
                        <img src="./../../img/first01.png" class="img1" />
                        <img src="./../../img/first00.png" class="img2" />
                    </div>
                </div>
                <div class="mySecond" @click="mysecondJump('4')" style="margin-left:31px">
                    <img class="my_img" src="./../../img/first05.png" alt="法律服务" />
                    <p class="my_p1">法律服务</p>
                    <p class="my_p2" style="margin:8px 0;">法律维权服务</p>
                    <p class="my_p3">互联网法院在线办理</p>
                    <div class="jiantou">
                        <span class="show_span">了解详情</span>
                        <img src="./../../img/first01.png" class="img1" />
                        <img src="./../../img/first00.png" class="img2" />
                    </div>
                </div>
                <div class="mySecond"  @click="mysecondJump('5')" style="margin-left:31px">
                    <img class="my_img" src="./../../img/first06.png" alt="版权登记" />
                    <p class="my_p1">版权登记</p>
                    <p class="my_p2" style="margin:8px 0;">版权维权的有利证据</p>
                    <p class="my_p3">快速、高效确权</p>
                    <div class="jiantou">
                        <span class="show_span">了解详情</span>
                        <img src="./../../img/first01.png" class="img1" />
                        <img src="./../../img/first00.png" class="img2" />
                    </div>
                </div>
            </div>
           
            
        
        </div>
    </div>
</template>

<script>
    export default {
        name:'firsecond',
        data(){
            return{

            }
        },
        methods:{
            mysecondJump(number){
                switch(number){
                    case '1':
                        this.$router.push({ path:'/copyrightEvidence' })
                        break;
                    case '2':
                        this.$router.push({ path:'/monitorIntroduce' })
                        break;
                    case '3':
                        this.$router.push({ path:'/evidence' })
                        break;
                    case '4':
                        this.$router.push({ path:'/lawService' })
                        break;
                    case '5':
                        this.$router.push({ path:'/toReg' })
                        break;
                    case '6':
                        this.$router.push({ path:'/preLogin' })
                        break;
                  default:
                        break;
                }
            }
        }
    }
</script>

<style scoped lang="less">
    .firsecond_content{
        height:600px;
        background:rgba(248,248,248,1);
        .middletf{
            width:1334px;
            margin:0 auto;
            overflow: hidden;
            .firsecond_top{
                text-align: center;
                font-size:36px;
                font-weight:bold;
                color:rgba(18,18,16,1);
                letter-spacing:2px;
                margin:50px 0 23px;
                .top_img{
                    width:219px;
                    height: 53px;
                    position: relative;
                    top:-37px;
                }
            }
            .firsecond_bottom{
                display: flex;
                justify-content: flex-start;
                width:1265px;
                margin:0 auto;
            }
            .mySecond{
                display:flex;
                flex-direction: column;
                align-items: center;
                width:242px;
                height:328px;
                background:rgba(255,255,255,1);
               
                .my_img{
                    width:85px;
                    height:85px;
                    margin-top:45px;
                    margin-bottom:28px;
                }
                .my_p1{
                    font-size:18px;
                    font-weight:bold;
                    color:rgba(51,51,51,1);
                }
                .my_p2{
                    font-size:14px;
                    font-weight:400;
                    color:rgba(102,102,102,1);
                }
                .jiantou{                    
                    width:94px;
                    height:30px;
                    vertical-align: middle;
                    text-align:center;
                    line-height:30px;
                    margin-top: 20px;
                    .show_span{
                        font-size:12px;
                        color: #fff;
                        display: none;
                        margin-right: 6px;
                    }
                    img{
                        width:16px;
                        height:16px;
                        vertical-align: middle;
                        text-align:center;
                    }
                    .img2{
                        display: none;
                    }
                }
                &:hover{
                    width:242px;
                    height:338px;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 2px 40px 0px rgba(29,31,108,0.04);
                    cursor:pointer;
                    .jiantou{
                        background:rgba(18,18,16,1);
                    }
                    .show_span{
                        display: inline-block;
                    }
                    .img1{
                        display: none;
                    }
                    .img2{
                        display: inline-block;
                    }
                }
            }
        }
    }
</style>